module.exports = __webpack_public_path__ + "img/ke.332964d1.png";